import { Navigate } from 'react-router-dom'
import { useAuth } from '@/features/auth/AuthContext'
import { DashboardPage } from '@/pages/DashboardPage'

/** Root `/` — redirects each role to their home page on login. */
export function ResidentsHome(): React.JSX.Element {
  const { user } = useAuth()
  if (user?.role === 'THINKADMIN') return <Navigate to="/admin/clients" replace />
  return <Navigate to="/residents" replace />
}

/** `/residents` — THINKADMIN has no facility so redirect; everyone else sees residents. */
export function ResidentsPage(): React.JSX.Element {
  const { user } = useAuth()
  if (user?.role === 'THINKADMIN') return <Navigate to="/admin/clients" replace />
  return <DashboardPage />
}
